import { FAVORITES_KEY } from '../screens/App/snippets/Tests&Visits/utils';
import store from '../store';
import {
    decrypt,
    encrypt
} from '../utils';
import { storage } from './localstorage';

export const setFavoritesToStorage = async (favorites = [], profileId, hashKey) => {
    const info = store.getState?.().user?.info ?? {};
    const {
        me = {},
        hashKey: hash,
    } = info;
    const profileId1 = me?.profileId;
    if (!(profileId || profileId1) || !(hashKey || hash)) {
        return;
    }
    storage
        .get(FAVORITES_KEY)
        .then((allFavorites) => {
            const favoritesData = typeof allFavorites === 'object' && allFavorites !== null ? { ...allFavorites } : {};
            favoritesData[profileId ?? profileId1] = favorites?.map((f) => encrypt(f, hashKey ?? hash));
            storage
                .set(FAVORITES_KEY, favoritesData)
                .then()
                .catch((err) => {
                    console.log('Error set favorites int', { err });
                });
        })
        .catch((err) => {
            console.log('Error set favorites out', { err });
        });
};

export const getFavoritesFromStorage = async (profileId, hashKey) => {
    const info = store.getState?.().user?.info ?? {};
    const {
        me = {},
        hashKey: hash,
    } = info;
    const profileId1 = me?.profileId;
    if (!(profileId || profileId1) || !(hashKey || hash)) {
        console.log('setFavorites: no profileId or hashKey', { info });
        return [];
    }
    const favorites = await storage.get(FAVORITES_KEY);
    const favoritesData = typeof favorites === 'object' && favorites !== null ? { ...favorites } : {};
    const favoritesList = favoritesData[profileId ?? profileId1] || [];
    return favoritesList.map((e) => decrypt(e, hashKey));
};
